<template>
  <nav class="fixed inset-0 z-[999999] overflow-y-auto bg-white px-6 pt-6 lg:hidden">
    <div class="mb-14 flex items-center justify-between">
      <a href="/" class="inline-block">
        <NavigationLogo></NavigationLogo>
        <span class="sr-only">Startpagina</span>
      </a>

      <button class="flex items-center text-xs font-bold text-text-dark" @click="close">
        SLUITEN
        <div class="p-2.5">
          <BaseIcon :icon="'X'"></BaseIcon>
        </div>
      </button>
    </div>

    <ul class="space-y-8">
      <li v-for="item in navItems" :key="item.name">
        <NavMobileOverlayCollapse
          v-if="item.hasChildren"
          v-model="activeCollapses[item.name]"
          :title="item.name"
          :options="item.children"
          @toggle="handleCollapseChange(item.name)"
        ></NavMobileOverlayCollapse>

        <a
          v-else
          :href="item.url"
          :aria-label="item.name"
          class="block w-full border-b border-border-light pb-4 font-poppins text-display-md font-extrabold text-text-dark no-underline"
        >
          {{ item.name }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import type { INavMobileOverlay } from '@/features/navigation/components/NavMobileOverlay/types/INavMobileOverlay.ts'
import NavigationLogo from '@/features/navigation/components/NavigationLogo/NavigationLogo.vue'
import BaseIcon from '@/common/components/base/BaseIcon/BaseIcon.vue'
import NavMobileOverlayCollapse from '@/features/navigation/components/NavMobileOverlay/NavMobileOverlayCollapse.vue'
import { ref } from 'vue'

defineProps<INavMobileOverlay>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const close = () => {
  emit('close')
}

// Track which collapses are open
const activeCollapses = ref<Record<string, boolean>>({})

const handleCollapseChange = (name: string) => {
  // Close other collapses when one is opened
  if (activeCollapses.value[name]) {
    Object.keys(activeCollapses.value).forEach(key => {
      if (key !== name) {
        activeCollapses.value[key] = false
      }
    })
  }
}
</script>
